import { ForwardRefRenderFunction, forwardRef, useMemo } from "react";
import * as Yup from "yup";

// #region types
import { SalaryFormTypes } from "models/formTypes";
import { FormHandles } from "models/propTypes/genericFormProps";
import { ChildCreateFormContainerProps } from "models/propTypes/wintSalaryPropTypes";
// #endregion

// #region components
import useWintSalaryDeviationService from "serviceHooks/useWintSalaryDeviationService";
import { TranslationKeys } from "translations";
import ChildCreateForm from "./childCreateForm";
// #endregion

const ChildCreateFormContainer: ForwardRefRenderFunction<FormHandles, ChildCreateFormContainerProps> = (props, ref) => {
  const { personId, onChildCreated, onFormValidationChange } = props;
  const { createChildForPersonApi } = useWintSalaryDeviationService();

  const validationSchema = useMemo(
    () =>
      Yup.object<SalaryFormTypes.ChildCreate>({
        name: Yup.string().trim().required(TranslationKeys.Validations.Required),
        dateOfBirth: Yup.date()
          .typeError(TranslationKeys.Validations.InvalidDate)
          .required(TranslationKeys.Validations.Required),
        soleCustody: Yup.boolean().required(),
      }),
    []
  );

  const defaultValues: SalaryFormTypes.ChildCreate = {
    name: "",
    soleCustody: false,
  };

  const submitHandler = async (values: SalaryFormTypes.ChildCreate) => {
    const request = {
      name: values.name.trim(),
      dateOfBirth: values.dateOfBirth!,
      soleCustody: values.soleCustody,
    };
    const created = await createChildForPersonApi(personId, request);
    if (created) {
      onChildCreated?.(created);
    }
    return created;
  };

  return (
    <ChildCreateForm
      ref={ref}
      defaultValues={defaultValues}
      validationSchema={validationSchema}
      handleSubmit={submitHandler}
      onFormValidationChange={onFormValidationChange}
    />
  );
};

export default forwardRef(ChildCreateFormContainer);
